import React from 'react'
import { useDispatch, useSelector } from 'react-redux';



export function checkPrivilege(privilegeToBeChecked) {
    const dispatch = useDispatch();
    const privileges = useSelector(state => state.Privilages.privileges)
    if (privileges.hasOwnProperty(privilegeToBeChecked) && privileges[privilegeToBeChecked]) {
        
        return true;
    } else {

        return false;
    }
}
